export default __webpack_public_path__ + "static/media/the_solemn.60aea49f.gif";